import React from 'react';
import PropTypes from 'prop-types';
import { TabList } from 'cstar-react-primitives';

import { ELECTRONIC_DELIVERY, PHYSICAL_DELIVERY } from '../../products/productsModule';

import { cashbotName } from './coreUtils';

export const DeliveryMethodSelection = ({
    legend,
    digitalLabel,
    physicalLabel,
    handleChange,
    selectedMethod
}) => {
    const deliveryMethodProps = {
        legend,
        cashbotName,
        defaultValue: selectedMethod,
        name: 'personalize-delivery-method',
        cssClass: 'personalize-delivery-method'
    };
    return (
        <TabList
            {...deliveryMethodProps}
            fullWidth
            tabItems={[
                {
                    label: digitalLabel,
                    value: ELECTRONIC_DELIVERY
                },
                {
                    label: physicalLabel,
                    value: PHYSICAL_DELIVERY
                }
            ]}
            handleSelect={handleChange}
        />
    );
};

DeliveryMethodSelection.defaultProps = {
    selectedMethod: ELECTRONIC_DELIVERY
};

DeliveryMethodSelection.propTypes = {
    legend: PropTypes.string.isRequired,
    digitalLabel: PropTypes.string.isRequired,
    physicalLabel: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    selectedMethod: PropTypes.oneOf([ELECTRONIC_DELIVERY, PHYSICAL_DELIVERY])
};
